import * as React from 'react';
export const IcScanBody = (
  props: React.SVGProps<SVGSVGElement>
): JSX.Element => (
  <svg
    viewBox='0 0 24 24'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path
      d='M7 20H5a1 1 0 01-1-1v-2a1 1 0 10-2 0v2a3 3 0 003 3h2a1 1 0 000-2zM3 8a1 1 0 001-1V5a1 1 0 011-1h2a1 1 0 000-2H5a3 3 0 00-3 3v2a1 1 0 001 1zm8.5-1a1.5 1.5 0 100-3 1.5 1.5 0 000 3zm1 5.12v-1.56A7.507 7.507 0 0015 11a1 1 0 000-2 6.11 6.11 0 01-2.95-.83h-.08l-.19-.07a.58.58 0 00-.19 0L11.5 8c-.2 0-2 .06-4.21 2.29a1 1 0 00.325 1.639 1 1 0 001.095-.219 6.79 6.79 0 011.79-1.35v2.06a10 10 0 01-2.21 4.87 1 1 0 00.325 1.639 1 1 0 001.095-.219 10.19 10.19 0 002.26-4 32.78 32.78 0 012.14 3.7.999.999 0 00.89.59.93.93 0 00.45-.11 1 1 0 00.44-1.34 27.492 27.492 0 00-3.39-5.43zM21 16a1 1 0 00-1 1v2a1 1 0 01-1 1h-2a1 1 0 000 2h2a3 3 0 003-3v-2a1 1 0 00-1-1zM19 2h-2a1 1 0 100 2h2a1 1 0 011 1v2a1 1 0 002 0V5a3 3 0 00-3-3z'
      fill='currentColor'
    />
  </svg>
);
